module.exports = __webpack_public_path__ + "img/condition_monitor_screenshot.c6026d37.png";